import React from "react";
import { useAnnounceWhen } from "../../hook/useA11yAnnouncements";

export const RegistrationRequiredMark = () => (
  <span className="required-mark" aria-hidden="true">
    *
  </span>
);

export const RegistrationAnnouncedText = ({
  message,
  level = "normal",
  className = "section-sub",
}) => {
  useAnnounceWhen(Boolean(message), message, level);
  return <p className={className}>{message}</p>;
};
